import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';
import { ActivatedRoute } from '@angular/router';
import { ObtenerDatosService } from 'src/app/servicios/datos/obtener-datos/obtener-datos.service';
import { RutasService } from 'src/app/servicios/rutas/rutas.service';

// declare var $;
// import * as $ from 'jquery';
import { ThemeService } from '../../../../../theme/theme.service';

@Component({
  selector: 'app-ppyci-circunscripcion',
  templateUrl: './ppyci-circunscripcion.component.html',
  styleUrls: ['./ppyci-circunscripcion.component.scss']
})
export class PpyciCircunscripcionComponent implements OnInit {

  base: string;
  contenido: any = [];
  resumenVotacion: any;


  constructor(
    public _globalService: GlobalesService,
    public activatedRoute: ActivatedRoute,
    public _obtenerDatosService: ObtenerDatosService,
    public rutasService: RutasService,
    public themeService: ThemeService,
  ) { }

  ngOnInit(): void {
    this.checkInicial();
    this.base = `/${this.rutasService.rutaActual.base}/tarjetas`;
    // $('[data-toggle="tooltip"]').tooltip();
  }

  checkInicial() {
    this.obtenerParametro();
  }

  obtenerParametro() {
    return new Promise((res, rej) => {
      this.activatedRoute.params.subscribe((param) => {
        this._globalService.detalles = param;
        res();
      });
    })
  }

 

  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;

  public scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 150), behavior: 'smooth' });
  }

  public scrollLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 150), behavior: 'smooth' });
  }

}
